import {isImmutable as isImmutableValue} from "immutable";


// Helper to check if a value is an Immutable.js structure
const isImmutable = (value: any): boolean => {
    return isImmutableValue(value);
};

// Custom serializable check that allows Immutable.js structures and class instances
export const isSerializable = (value: any): boolean => {
    // Allow Immutable.js structures
    if (isImmutable(value)) {
        return true;
    }
    // Allow primitives
    if (value === null ||
        typeof value === "undefined" ||
        typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean") {
        return true;
    }
    // Allow arrays
    if (Array.isArray(value)) {
        return true;
    }
    // Allow objects (including class instances) - but check they don't contain functions/symbols
    if (typeof value === "object") {
        // Check if object has any non-serializable properties
        try {
            // Try to serialize to JSON - if it works, it's serializable
            JSON.stringify(value);
            return true;
        } catch {
            // If JSON.stringify fails, it's not serializable
            return false;
        }
    }
    return false;
};